'use client';

import { useCartState } from '@/core/application/providers/StateMachineProvider';
import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';
import { CartPreviewHeader } from './CartPreviewHeader';
import { CartItemsList } from './CartItemsList';
import { CartPreviewFooter } from './CartPreviewFooter';

interface CartPreviewModalProps {
  onClose: () => void;
}

export function CartPreviewModal({ onClose }: CartPreviewModalProps) {
  const { items, itemCount, total, isEmpty, isLoading, hasError } = useCartState();
  const [isVisible, setVisibility] = useState(true);

  const handleClose = () => {
    setVisibility(false);
  };

  const onExitAnimationComplete = (definition: { animationName: string }) => {
    if (definition.animationName === 'exit-cart-preview') {
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 z-50 overflow-hidden flex justify-end md:px-6 px-3">
      <div className="backdrop-blur-sm h-full w-full" onClick={handleClose}></div>

      <AnimatePresence>
        {isVisible && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20, animationName: 'exit-cart-preview' }}
            onAnimationComplete={onExitAnimationComplete}
            className="absolute top-20 md:top-16 bg-white rounded-2xl shadow-2xl md:w-full w-[calc(100vw-1.4rem)] md:max-w-xs max-h-[80vh] overflow-hidden">
            <CartPreviewHeader itemCount={itemCount} isEmpty={isEmpty} onClose={handleClose} />

            <CartItemsList
              items={items}
              isLoading={isLoading}
              hasError={hasError}
              isEmpty={isEmpty}
              onMenuLinkClick={handleClose}
            />

            <CartPreviewFooter
              total={total}
              isEmpty={isEmpty}
              isLoading={isLoading}
              hasError={hasError}
              onOrderNowClick={onClose}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
